import type { SignalRNotification } from '../hooks/useSignalR';

export const IMPORT_USERS_COMPLETED_EVENT = 'import-users-completed';
export const IMPORT_TEAMS_COMPLETED_EVENT = 'import-teams-completed';

const IMPORT_USER_NOTIFICATION_TITLE = 'Importação de Usuários';
const IMPORT_TEAM_NOTIFICATION_TITLE = 'Importação de Equipes';

export function shouldRefreshAfterImportNotification(notification: SignalRNotification): boolean
{
  if (notification.type !== 'success' && notification.type !== 'warning')
  {
    return false;
  }

  const title = notification.title?.trim() ?? '';
  return title === IMPORT_USER_NOTIFICATION_TITLE || title === IMPORT_TEAM_NOTIFICATION_TITLE;
}

export function dispatchImportCompletedEvent(notification: SignalRNotification): void
{
  const title = notification.title?.trim() ?? '';

  if (title === IMPORT_USER_NOTIFICATION_TITLE)
  {
    window.dispatchEvent(
      new CustomEvent(IMPORT_USERS_COMPLETED_EVENT, { detail: notification })
    );
    return;
  }

  if (title === IMPORT_TEAM_NOTIFICATION_TITLE)
  {
    window.dispatchEvent(
      new CustomEvent(IMPORT_TEAMS_COMPLETED_EVENT, { detail: notification })
    );
  }
}
